/**
 * Checks the application hostname to determine if the legal name of the application is Liveboard
 * @returns {RegExpMatchArray}
 */
function isLiveboard() {
  if (window?.location?.hostname == null) return false;
  return window.location.hostname.match(/liveboard.co.jp/);
}

export default isLiveboard;
